import { Download } from "lucide-react";
export default function HeroSection() {
  return <section style={{
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(244, 244, 243)",
    fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
    position: "relative",
    overflow: "hidden",
    backgroundColor: "#0B0B0D",
    paddingTop: "120px",
    paddingBottom: "100px"
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
        .hero-btn-primary:hover { opacity: 0.9; transform: scale(1.02); }
        .hero-btn-secondary:hover { background: rgba(255,255,255,0.06); transform: scale(1.02); }
        .hero-btn-primary, .hero-btn-secondary { transition: all 0.14s ease; cursor: pointer; display: inline-flex; align-items: center; gap: 8px; }
      `}</style>

      <div className="hero__glow" style={{
      backgroundImage: "radial-gradient(620px 420px at 78% 18%, rgba(245, 197, 24, 0.1), rgba(0, 0, 0, 0) 70%)",
      backgroundPosition: "0% 0%",
      backgroundRepeat: "repeat",
      color: "rgb(244, 244, 243)",
      fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
      position: "absolute",
      inset: 0,
      pointerEvents: "none"
    }} />

      <div className="page-container" style={{
      position: "relative",
      zIndex: 1
    }}>
        <div className="flex flex-col md:flex-row items-center justify-between gap-12 md:gap-0">
          <div className="flex flex-col w-full md:w-auto" style={{
          maxWidth: "680px"
        }}>
            <div className="flex items-center gap-2 mb-5">
              <div style={{
              width: "8px",
              height: "8px",
              backgroundColor: "#F5C518",
              flexShrink: 0
            }} />
              <span style={{
              color: "#76767D",
              fontSize: "11px",
              fontWeight: 600,
              letterSpacing: "0.08em",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              textTransform: "uppercase"
            }}>
                OPEN-SOURCE AI · MADE IN COLOMBIA
              </span>
            </div>

            <h1 style={{
            color: "rgb(244, 244, 243)",
            fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
            fontSize: "clamp(48px, 8vw, 83.2px)",
            fontWeight: "620",
            lineHeight: "1.04",
            letterSpacing: "-3.744px",
            border: "0px none rgb(244, 244, 243)",
            margin: 0,
            marginBottom: "30px"
          }}>
              Ranks{" "}
              <span style={{
              color: "#F5C518"
            }}>#3</span>
              {"."}<br />
              Behind only<br />
              Claude<br />
              and GPT-4o.
            </h1>

            <p style={{
            color: "rgb(185, 185, 189)",
            fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
            fontSize: "22.4px",
            fontWeight: "400",
            lineHeight: "33.6px",
            letterSpacing: "-0.336px",
            border: "0px none rgb(185, 185, 189)",
            margin: 0,
            marginBottom: "38px",
            maxWidth: "480px"
          }}>
              Orchid 1.0 is a 2-billion-parameter ternary-weight language model fine-tuned on a{" "}
              <strong style={{
              fontWeight: 700,
              color: "rgb(185, 185, 189)"
            }}>
                single 4 GB laptop GPU
              </strong>
              . On our internal benchmark it outscores every open-weight model we tested — including 7B–9B systems.
            </p>

            <div className="flex flex-wrap items-center gap-3 mb-6">
              <a href="#" className="hero-btn-primary" style={{
              color: "rgb(26, 21, 0)",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              fontSize: "16.64px",
              fontWeight: "600",
              lineHeight: "26.624px",
              letterSpacing: "-0.1664px",
              backgroundColor: "rgb(245, 197, 24)",
              borderRadius: "10px",
              border: "1px solid rgb(245, 197, 24)",
              padding: "14.976px 24.96px",
              textDecoration: "none"
            }}>
                Download Orchid Desktop
                <span dangerouslySetInnerHTML={{
                __html: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="17" height="17"><path d="M12 4v12m0 0l-5-5m5 5l5-5M4 20h16"></path></svg>`
              }} />
              </a>

              <a href="#" className="hero-btn-secondary" style={{
              color: "rgb(244, 244, 243)",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              fontSize: "16.64px",
              fontWeight: "540",
              lineHeight: "26.624px",
              letterSpacing: "-0.1664px",
              borderRadius: "10px",
              border: "1px solid rgba(255, 255, 255, 0.16)",
              padding: "14.976px 24.96px",
              textDecoration: "none",
              background: "transparent"
            }}>
                Explore the model
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-2">
              <span style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "4px",
              border: "1px solid rgba(255, 255, 255, 0.16)",
              borderRadius: "20px",
              padding: "5px 12px",
              fontSize: "13px",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              color: "rgb(185, 185, 189)"
            }}>
                <strong style={{
                fontWeight: 700,
                color: "rgb(244, 244, 243)"
              }}>2B</strong>
                {" "}ternary weights
              </span>

              <span style={{
              display: "inline-flex",
              alignItems: "center",
              border: "1px solid rgba(255, 255, 255, 0.16)",
              borderRadius: "20px",
              padding: "5px 12px",
              fontSize: "13px",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              color: "rgb(185, 185, 189)",
              backgroundColor: "rgba(255,255,255,0.04)"
            }}>
                Apache 2.0
              </span>

              <span style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "4px",
              border: "1px solid rgba(255, 255, 255, 0.16)",
              borderRadius: "20px",
              padding: "5px 12px",
              fontSize: "13px",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              color: "rgb(185, 185, 189)",
              backgroundColor: "rgba(255,255,255,0.04)"
            }}>
                Runs{" "}
                <strong style={{
                fontWeight: 700,
                color: "rgb(244, 244, 243)"
              }}>CPU-only</strong>
              </span>

              <span style={{
              display: "inline-flex",
              alignItems: "center",
              border: "1px solid rgba(255, 255, 255, 0.16)",
              borderRadius: "20px",
              padding: "5px 12px",
              fontSize: "13px",
              fontFamily: 'Geist, "Hanken Grotesk", system-ui, -apple-system, sans-serif',
              color: "rgb(185, 185, 189)"
            }}>
                Win · Linux
              </span>
            </div>
          </div>

          <div className="flex items-center justify-center md:justify-end flex-shrink-0">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1707747/img/orchid-logo.png" alt="Orchid — pixel-art flower mark" className="w-full h-auto" style={{
            maxWidth: "300px",
            imageRendering: "pixelated"
          }} />
          </div>
        </div>
      </div>
    </section>;
}